const ContactHeader = ({ data }) => {
  return (
    <>
      <div className="flex md:items-center md:justify-between md:flex-row flex-col gap-15">
        <div className="flex">
          <div className="pe-4 border-e border-border-color ">
            <div className="md:text-[14px]/[20px] text-[12px]/[16px] text-font-color-100 uppercase">
              დასახელება
            </div>
            <div className="flex items-end gap-1 flex-wrap">
              <span className="md:text-[20px]/[26px] font-medium">
                {data?.name}
              </span>
            </div>
          </div>
          <div className="pe-4 border-e border-border-color ml-6">
            <div className="md:text-[14px]/[20px] text-[12px]/[16px] text-font-color-100 uppercase">
              პირადი/საიდენტიფიკაციო ნომერი
            </div>
            <div className="flex items-end gap-1 flex-wrap">
              <span className="md:text-[20px]/[26px] font-medium">
                {data?.personalId}
              </span>
            </div>
          </div>
          <div className="pe-4 border-e border-border-color ml-6">
            <div className="md:text-[14px]/[20px] text-[12px]/[16px] text-font-color-100 uppercase">
              ტიპი
            </div>
            <div className="flex items-end gap-1 flex-wrap">
              <span className="md:text-[20px]/[26px] font-medium">
                {data?.userTypeId == 1 ? "ფიზიკური პირი" : "იურიდიული პირი"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactHeader;
